import { render, staticRenderFns } from "./beneficiary-email.vue?vue&type=template&id=d65f6fd0&"
import script from "./beneficiary-email.vue?vue&type=script&lang=js&"
export * from "./beneficiary-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports